import axios, { AxiosResponse } from 'axios';

export type TachographSummary = {
  drivingTimeMillis: number;
  workTimeMillis: number;
  restTimeMillis: number;
  availabilityTimeMillis: number;
  noCardTimeMillis: number;
};

export enum TachographState {
  DRIVING = 'DRIVING',
  WORK = 'WORK',
  AVAILABILITY = 'AVAILABILITY',
  REST = 'REST',
  NO_CARD = 'NO_CARD',
}

export type TachographStateWithTime = {
  state: TachographState;
  startInDayMillis: number;
  stopInDayMillis: number;
};

export type TachographBorderCrossings = {
  timeInDayMillis: number;
  fromCountry: { code: string; name: string };
  toCountry: { code: string; name: string };
};

export type TachographDriversName = {
  timeInDayMillis: number;
  driverName: string;
};

export type TachographDataInDay = {
  date: string;
  summary: TachographSummary;
  states: TachographStateWithTime[];
  borderCrossings: TachographBorderCrossings[];
  driversName: TachographDriversName[];
};

export type TachographDataDuringFromToPeriod = {
  fromDate: Date;
  toDate: Date;
  summary?: TachographSummary;
  states?: TachographStateWithTime[];
  borderCrossings?: TachographBorderCrossings[];
  driversName?: TachographDriversName[];
};

export type TachographDiagramRequest = {
  targetId: number;
  fromTimeMillis: number;
  toTimeMillis: number;
};

export type DateType = {
  from: Date;
  to: Date;
};

export async function tachograph(
  targetId: number,
  fromDate: string,
  toDate: string,
  signal: AbortSignal
): Promise<AxiosResponse<TachographDataInDay[] | undefined>> {
  const url = `/api/v1.1/tachograph/status-history?targetId=${targetId}&fromDate=${fromDate}&toDate=${toDate}`;
  return axios.get<TachographDataInDay[]>(url, { signal });
}
